import React from "react";
import PropsGroup from "./PropsGroup"

const PropsContainer: React.FC<{properties: any, doSave: (params: any)=>Promise<any>}> = (props) => {
    return (
        <>
            {props.properties.map((item: any, i: number) => (<PropsGroup key={i} groupProp={item} doSave={props.doSave}/>))}
        </>
    );
};

export default PropsContainer;
